import a from "./ghl-ui.es1550.js";
function i(e) {
  var t = a(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
export {
  i as default
};
